import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AttachOrderFilesModalData } from './attach-order-files-modal-data';
import { CommonModule } from '@angular/common';
import { Button } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { firstValueFrom } from 'rxjs';
import { AttachOrderFilesComponent, OrderFilesAttachProgressEvent } from 'app/components/attach-order-files';
import { FileInfo } from 'app/core/models';

@Component({
  selector: 'wl-attach-order-files-modal',
  standalone: true,
  imports: [CommonModule, AttachOrderFilesComponent, Button, TranslatePipe, MatIconModule],
  templateUrl: './attach-order-files-modal.component.html',
  styleUrl: './attach-order-files-modal.component.scss',
})
export class AttachOrderFilesModalComponent implements OnInit {
  private readonly _config = inject<DynamicDialogConfig<AttachOrderFilesModalData>>(DynamicDialogConfig);
  private readonly _ref = inject(DynamicDialogRef);

  protected readonly data = this._config.data;
  protected anyFilesChanged = false;
  protected anyInProgressFiles = false;
  protected hasFiles = false;
  protected files?: FileInfo[];
  protected posting = false;

  ngOnInit() {
    firstValueFrom(this.data!.files).then(v => {
      this.files = v;
      this.hasFiles = v.length > 0;
    });
  }

  protected onClose() {
    const { anyFilesChanged } = this;
    this._ref.close({
      anyFilesChanged,
    });
  }

  protected async onPost() {
    if (this.posting) return;

    if (!this.data!.postFn) return;

    this.posting = true;

    if (await this.data!.postFn()) {
      this._ref.close({
        anyFilesChanged: false,
      });
    }
    this.posting = false;
  }

  protected onProgress({ uploadingFiles, removingFiles, hasFiles }: OrderFilesAttachProgressEvent) {
    this.anyInProgressFiles = !!uploadingFiles?.length || !!removingFiles?.length;
    if (hasFiles != null) {
      this.hasFiles = hasFiles;
    }
  }
}
